import React, { useEffect, useRef, useState } from "react";
import { api, getToken } from "../../../../services/apis/auth-api/apiUrl";
import { GET_LEAVE_REQUEST_DATA_BY_ID, UPDATE_LEAVE_REQUEST_STATUS } from "../../../../config/config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-regular-svg-icons";
import { faCopy, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { frontEndUrl } from "../../../../services/apis/auth-api/apiUrl";

interface LeaveDetailsComponents {
    id : number
}

interface LeaveRequest {
    leave_type: string;
    days_on_leave: number; 
    leave_dates : string; 
    leave_body: string;
    status: string;
    approval_link: string;
    date_requested: string; 
    requester_f_name: string;
    requester_l_name: string;
    approver_f_name: string;
    approver_l_name: string;
  }
  
const LeaveDetails : React.FC<LeaveDetailsComponents> = ({id}) => {
    const [leaveReqDetails, setLeaveReqDetails] = useState<LeaveRequest | null>(null);
    const [dateLeaves, setDateLeaves] = useState<string[]>([]);
    const [copyNotif, setCopyNotif] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const inputRef = useRef<HTMLInputElement>(null);

    const formatDate = (dateString: string | undefined): string => {
        if(!dateString) return "";
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    };

    const copyToClipboard = () => {
        if(inputRef.current){
            navigator.clipboard.writeText(inputRef.current.value);
            setCopyNotif('Approval link copied!');
        }
    }

    const cancelLeave = async() => {
        if(!id) return false;
        setLoading(true);
        try{
            await api.put(UPDATE_LEAVE_REQUEST_STATUS+id, {
                stat : 'Cancelled'
            }, {headers: { 'Authorization': 'Bearer ' + getToken() }});
            setLoading(false);
        }catch(e){
            setLoading(false);
        }
    }

    useEffect(()=>{
        const retrieveLeavReqData = async() => {
            try{
                const api_data = await api.get(GET_LEAVE_REQUEST_DATA_BY_ID+id, {
                    headers: { 'Authorization': 'Bearer ' + getToken() }
                })
                const details = api_data.data as LeaveRequest;
                setLeaveReqDetails(details);
                setDateLeaves(JSON.parse(details.leave_dates));
            }catch(e){}
        }
        if(!loading) retrieveLeavReqData();
    },[id, loading])

    return (
        <div className="min-w-[38rem] max-w-[38rem] text-gray-700 relative">
            <div className={leaveReqDetails === null || loading ? 'modal-loader' : 'hidden'}>
                <FontAwesomeIcon className="animate-spin" icon={faSpinner} />
            </div>
            <div className="my-2">
                <h1 className="uppercase font-medium">
                    <FontAwesomeIcon icon={faFile} />&nbsp;
                    Leave details
                </h1>
            </div>
            <hr className="border-gray-400" />
            <div className="my-2">
                <div className="flex gap-2 items-center">
                    <h2>Subject: </h2>
                    <p className="font-medium">
                        {leaveReqDetails?.leave_type === 'vl' ? 'Vacation Leave' : 'Sick/Emergency Leave'} Request
                    </p>
                </div>
                <div className="flex gap-2 items-center">
                    <h2>Approver: </h2>
                    <p className="font-medium">
                        {leaveReqDetails?.approver_f_name} {leaveReqDetails?.approver_l_name}
                    </p>
                </div>
                <div className="flex gap-2 items-center">
                    <h2>Status: </h2>
                    <p className="font-medium">
                        {leaveReqDetails?.status}
                    </p>
                </div>
                <div className="flex gap-2 items-center">
                    <h2>Date Requested: </h2>
                    <p className="font-medium">
                        {formatDate(leaveReqDetails?.date_requested)}
                    </p>
                </div>
                <div className="flex gap-2 items-center">
                    <h2>Date of leave: </h2>
                    <p className="font-medium">
                        {dateLeaves.map(date => (
                            formatDate(date)+', '
                        ))}
                    </p>
                </div>
                <div className="flex gap-2 items-center">
                    <h2>No. of leave: </h2>
                    <p className="font-medium">
                        {leaveReqDetails?.days_on_leave}
                    </p>
                </div>
            </div>
            <hr className="border-gray-400" />
            <div className="my-2">
                <p>
                    {leaveReqDetails?.leave_body}
                </p>
            </div>
            <hr className="border-gray-400" />
            <div>
                <label>
                    Approval link: <small className="text-green-600">{copyNotif}</small>
                </label>
            </div>
            <div className="flex gap-2 my-2">
                <input type="text" ref={inputRef} className="text-box text-xs h-6" value={`${frontEndUrl}hr-management/leave-approval/${leaveReqDetails?.approval_link}`} />
                <button type="button" onClick={copyToClipboard} className="border w-10 rounded shadow bg-gray-200">
                    <FontAwesomeIcon icon={faCopy} />
                </button>
            </div>
            <div className="my-2">
                {leaveReqDetails?.status === 'Pending' && (
                    <button type="button" onClick={cancelLeave} className="button button-red">
                        Cancel
                    </button>
                )}
            </div>
        </div>
    )
}

export default LeaveDetails;